angular.module('leanlaw').filter("amount", ['$filter', function ($filter) {
  return function (amount, showZero, decimalPlaces) {
    const roundTo = decimalPlaces || 2;
    if (!amount && showZero === false) {
      return "";
    }
    if (amount < 0) {
      return `(${$filter('currency')(-amount, '$', roundTo)})`;
    }
    return $filter('currency')(amount, '$', roundTo);
  };
}]).filter("amountNoZero", ['$filter', function ($filter) {
  return function (amount, decimalPlaces) {
    const roundTo = decimalPlaces || 2;
    if (!amount) {
      return "-";
    }
    if (amount < 0) {
      return `(${$filter('currency')(-amount, '$', roundTo)})`;
    }
    return $filter('currency')(amount, '$', roundTo);
  };
}]);